const MAX_FEATURED_STORIES = 4;

export const mergeWithFeaturedStories = ({
  otherStories = [],
  featuredStories = [],
}: {
  otherStories?: Queries.storyFragmentFragment[];
  featuredStories?: Queries.storyFragmentFragment[];
} = {}) => {
  // remove featured stories from otherStories
  const featuredStoriesId = featuredStories.map((s) => s.id);
  const deDupedStories = otherStories.filter(
    (s) => !featuredStoriesId.includes(s.id),
  );
  const numberofExtraStoriesNeeded =
    MAX_FEATURED_STORIES - featuredStories.length;

  const extraStoriesNeeded = deDupedStories.slice(
    0,
    numberofExtraStoriesNeeded,
  );

  const mergedStories = [...featuredStories, ...extraStoriesNeeded];

  return mergedStories;
};
